import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './stockdialog';
import Loading from '../loading';

class OrderStatus extends React.Component {

  state = {
    open: false,
    data: []
  }

  viewBranch() {
    let context = this;
    context.setState({ load: true, message: 'Getting Stock Details' })
    $.ajax({
      type: 'POST', url: Server() + 'dashboard/stockbranch.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let stockAmount;
    let data = this.props.data.map((x) => { stockAmount = x.stock_amount; });
    stockAmount = Number(stockAmount);
    stockAmount = stockAmount.toFixed(2);
    let fontSize = 20;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card style={{backgroundColor: '#abb119'}}>
              <div style={{fontSize: 17, color: 'white', padding: '5%'}}><b>Stocks</b></div>
              <br/>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <CardContent>
                      <center><b style={{color: 'white', paddingTop: '4%', fontSize: 18}}>{'₹'+stockAmount}</b></center>
                  </CardContent>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this)} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div>
              <Dialogbox col3="Stock(s)" col2="Branch" type="stock" data={this.state.data} open={this.state.open} handleClose={ () => { this.setState({ open: false }) }} title='Order Status Report' />
            </div>
          ) : (<div></div>)
        }
      </div>
    );
  }
}

export default OrderStatus;
